/**
 * Téléchargement d'un fichier généré côté client (exports CSV / Excel).
 *
 * Ticket support #29 : sous Safari, `XLSX.writeFile` (blob
 * `application/octet-stream`) produisait `unknown.xlsx`. On passe par un blob
 * au type MIME explicite + `<a download>` ajouté au DOM, et l'URL n'est libérée
 * qu'après coup (Safari lit le blob de façon asynchrone après le clic).
 */

export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const REVOKE_DELAY_MS = 10_000;

/**
 * @param {Blob} blob
 * @param {string} filename  nom complet, extension comprise (déjà nettoyé).
 * @param {{doc?:Document, url?:typeof URL, schedule?:(fn:()=>void, ms:number)=>void}} [env]
 *        dépendances injectables (tests) ; par défaut celles du navigateur.
 */
export function downloadBlob(blob, filename, env = {}) {
  const doc = env.doc ?? document;
  const urlApi = env.url ?? URL;
  const schedule = env.schedule ?? ((fn, ms) => setTimeout(fn, ms));

  const url = urlApi.createObjectURL(blob);
  const a = doc.createElement('a');
  a.href = url;
  a.download = filename;
  doc.body.appendChild(a);
  a.click();
  doc.body.removeChild(a);
  schedule(() => urlApi.revokeObjectURL(url), REVOKE_DELAY_MS);
}
